import Case from './CaseList/CaseList'
const comp={
  Case,
}
export default comp